import { useMemo } from 'react';
import type { ColumnType } from 'xui-pro';
import { useTranslation } from '@/hooks/useTranslation';

const useColumns = () => {
  const $ = useTranslation();

  const columns = useMemo(() => {
    return [
      {
        title: $('序号'),
        dataIndex: 'wiIndex'
      },
      {
        title: $('工时编码'),
        dataIndex: 'wiCode'
      },
      {
        title: $('工时名称'),
        dataIndex: 'wiName'
      },
      {
        title: $('地区'),
        dataIndex: 'region'
      }
    ] as ColumnType[];
  }, [$]);
  return columns;
};

export default useColumns;
